import { store } from '@atredux/store'
import { setIsSeawardFrameLoading, seawardIFrameLoadingStatus } from '@atredux/slices/iframeSlice'

export async function seawardSetupListener () {
    console.log('ATBase: Received seaward frame setup confirmation')
    store.dispatch(setIsSeawardFrameLoading(seawardIFrameLoadingStatus.SUCCESS))
    return true
}
